import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use"

// Connects to data-controller="frame-reload"
// Reloads a Turbo Frame with the changed field as a query param, so the
// server can render fields that depend on it.
export default class extends Controller {
  static targets = ['frame']
  static values = { url: String }
  static debounces = ['reload']

  connect() {
    useDebounce(this, { wait: 200 })
  }

  reload({ target }) {
    const params = new URLSearchParams({ [target.name]: target.value })

    this.frameTarget.src = `${this.urlValue}?${params}`
  }
}
